var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"object-fit":"fill","width":"100%","height":"100%"}},[_c('video',{ref:"videoRef",staticStyle:{"object-fit":"fill","width":"100%","height":"100%"},attrs:{"autoplay":"","controls":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }